/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Route preset update request
 */
export interface RoutePresetUpdateRequest {
  id: number;
  newName?: string;
  lpPairIds: Array<number>;
}
